import React from "react";
import { Route } from "react-router-dom";
import { AuthConsumer } from "./AuthProvider";

import ManyosSpinner from "../ManyosSpinner/ManyosSpinner";


export const AdminRoute = ({ component, ...rest }) => {

    const renderFn = (Component) =>  (props) => (
        <AuthConsumer>
            {({ isAdmin,signinRedirect,isAuthenticated }) => {


                if (!!Component && isAdmin()) {
                    return <Component {...props} />;
                } else {
                    if (!(isAuthenticated())){
                        signinRedirect();
                        return <ManyosSpinner/>
                    }else{
                        window.location.href='/';
                    }

                }
            }}
        </AuthConsumer>
    );

    return <Route {...rest} render={renderFn(component)} />;
};
